import { uriRoot } from 'configs'; 
export const ROOT = `${uriRoot}/settings/`;
export const MODULE = 'SETTINGS';
